<template>
  <app-page>
    <dx-data-grid
      :columns="columns"
      :data-source="dataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :scrolling="scrolling"
      :element-attr="gridAttr"
    >
      <dx-editing
        refresh-mode="full"
        :allow-adding="false"
        :allow-updating="false"
        :allow-deleting="false"
        mode="batch"
      />

      <dx-pager
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :visible="true"
        :info-text="'Seite {0} von {1} ({2} Ticketarten)'"
      />
      <dx-filter-row :visible="true" />
      <dx-paging :page-size="defaultPageSize" />
    </dx-data-grid>
  </app-page>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxEditing,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";

export default {
  components: {
    DxDataGrid,
    DxPager,
    DxFilterRow,
    DxPaging,
    DxEditing,
  },
  mixins: [DataGridMixin],
  data() {
    return {
      gridAttr: {},
      columns: [
        {
          dataField: "tariff_zone_id",
          caption: "Tarifzonen ID",
        },
        {
          dataField: "ticket_type_id",
          caption: "Kartenart ID",
        },
        {
          dataField: "name",
          caption: "Kartenname",
        },
        {
          dataField: "abbreviation",
          caption: "Abkürzung",
        },
        {
          dataField: "tariff_price_grade",
          caption: "Tarifstufe",
        },
        {
          dataField: "toggle_text",
          caption: "Zusatzinformationen",
        },
      ],
      dataSource: new CustomStore({
        key: ["tariff_zone_id", "ticket_type_id"],
        load: () => axios.get(`${this.$store.state.baseUrl}tickettype`),
      }),
    };
  },
};
</script>

<style scoped>
</style>
